var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DefaultLayout,{attrs:{"researchMenu":true,"researchInboundMenu":true}},[_c(_setup.InboundSearch)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }